import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ClaimsService } from '../../../services/claims.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { UserService } from '../../../services/user.service';
import { PageConfig } from '../../../shared/authorization/auth.config';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../shared/authorization/authorization.service';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { ConfigFilterComponent } from '../config-filter/config-filter.component';
import { ListService } from '../../../shared/services/list.service';
import { LoggerService } from '../../../shared/services/logger.service';

@Component({
  selector: 'ppl-config-list',
  standalone: true,
  imports: [ListTableComponent, ButtonComponent, ConfigFilterComponent],
  templateUrl: './config-list.component.html',
  styleUrl: './config-list.component.css',
})
export class ConfigListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_CONFIG_DATA;
  pageId: string = PAGE_CONSTANTS.CONFIG_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  programName!: string;
  lazyLoad = true;
  appliedFilters: any;
  configList: any[] = [];
  cols = [];

  fields = [
    { field: 'module', show: true },
    { field: 'category', show: true },
    { field: 'configKey', show: true }
  ];

  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;

  constructor(
    private router: Router,
    private logger : LoggerService,
    private sectionService: SectionsService,
    private referralDataService: ReferralDataService,
    private userService: UserService,
    private sharedDataService: SharedDataService,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService,
    private claimsService: ClaimsService,
    private listService: ListService,

  ) {}

  onAddConfig() {
    this.sectionService.setFlow('config');
    this.router.navigate(['/home/config', 'add']);
  }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
    this.getColumnData();
    this.searchConfig([]);
  }

  async getColumnData() {
    try {
        const tempCols = await this.sectionService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.CONFIG_LIST_PAGE_HEADERS,
          'billing'
        );
        this.cols = tempCols.columns;
    } catch (e) {
      this.logger.debug('Error in getting column data', e);
    }
  }

  rowClicked(rowDetail: any) {
    this.userService.setLeadEntry('config');
    this.sectionService.setFlow('config');
    this.userService.setSelectedLead(rowDetail.ngAppConfigId);
    this.claimsService.setFormData('config', rowDetail);
    setTimeout(() => {
      this.router.navigate(['/home/config', 'update']);
    }, 200);
  }

  onPageLoad(event: any) {
    this.searchConfig(
      this.appliedFilters,
      event.startingPageNumber,
      event?.first ?? 0
    );
  }

  onSearch(filters: any) {
    this.appliedFilters = filters;
    this.searchConfig(filters);
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    searchParams: [],
    startingPageNumber = 1
  ) {

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchConfig(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.configList = [];
    }
    const processedPayload = this.buildRequestPayload(
      'configListView',
      'createddate',
      filters,
      startingPageNumber
    );
      this.listService
        .getListData(processedPayload, 'billing')
        .subscribe((data: any) => {
          const records = data.responsedata;
          if (startingPageNumber > 1) {
            this.configList = [...this.configList, ...records];
          } else {
            this.configList = records;
          }
          if (this.childComponent) {
            this.childComponent.resetPagination(startingPageNumber, currentPage);
          }
        });

  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService
        .fetchPageAuthorization(this.programName, this.pageId, 'LIST')
        .subscribe((response) => {
          this.setRestrictions(response);
        });
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(
        pageConfig,
        this.pageId
      );
      this.actionsToBeHidden = this.authUtility.getHiddenActions(
        pageConfig,
        this.pageId
      );
    }
    this.isPageRestrictionLoaded = true;
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
}
